import {
  Box,
  Image,
  useColorMode,
  Button,
} from "@chakra-ui/react";

import React from "react";
import { FaLink, FaPaperPlane } from "react-icons/fa";
// Sample card from Airbnb

function Project(props) {
  const { colorMode, toggleColorMode } = useColorMode();
const isDark = colorMode === "dark";
  const property = {
    imageUrl: "https://bit.ly/2Z4KKcF",
    imageAlt: "Rear view of modern home with pool",
    beds: 3,
    baths: 2,
    title: "Modern home in city center in the heart of historic Los Angeles",
    formattedPrice: "$1,900.00",
    reviewCount: 34,
    rating: 4,
  };
  return (
    <Box
      maxW="sm"
      borderWidth="1px"
      borderRadius="lg"
      borderColor={isDark ? 'inherit' : 'bluegrey'}
      mr={4}
      mb={10}
      overflow="hidden"
      
    >
      <Image height={'300px'} src={props.src} alt={property.imageAlt} />

      <Box p="6">
        <Box display="flex" alignItems="baseline">
          <Box
            color="gray.500"
            fontWeight="semibold"
            letterSpacing="wide"
            fontSize="xs"
            textTransform="uppercase"
            ml="2"
          >
            {props.lang}
          </Box>
        </Box>

        <Box
          display={"flex"}
          alignSelf={"baseline"}
          mt="1"
          fontWeight="semibold"
          lineHeight="tight"
        >
          <Box ml={2}>{props.title}</Box>
        </Box>
        <Box ml={2} fontSize="sm">
          {props.description}
        </Box>
        <Box display="flex" mt="2" alignItems="center">

          {!props.private ? <Box as="span" ml="2" fontSize="sm">
            <a href={props.link} target="_blank" rel="noopener noreferrer"><Button leftIcon={<FaLink />}> View</Button></a>
          </Box> : "Repo is private"}
        </Box>
      </Box>
    </Box>
  );
}

export default Project;
